<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.os_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="os_vendname">
            <label class="weui-form-preview__label">{{
              customLabel.os_vendname || "供应商"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.os_vendname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="os_kind">
            <label class="weui-form-preview__label">{{
              customLabel.os_kind || "调账类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.os_kind
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_buyername">
            <label class="weui-form-preview__label">{{
              customLabel.os_buyername || "采购员"
            }}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.os_buyername }}
              <!-- <call-mobile :em-id="form.main.pp_buyerid"></call-mobile> -->
            </span>
          </div>
          <div class="weui-form-preview__item" slot="os_date">
            <label class="weui-form-preview__label">{{
              customLabel.os_date || "单据日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.os_date, 'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_currency">
            <label class="weui-form-preview__label">{{
              customLabel.os_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.os_currency }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="os_beforeamount">
            <label class="weui-form-preview__label">{{
              customLabel.os_beforeamount || "应付余额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.os_beforeamount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_afteramount">
            <label class="weui-form-preview__label">{{
              customLabel.os_afteramount || "调账后应付余额(元)"
            }}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.os_afteramount, '¥#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="os_paydate">
            <label class="weui-form-preview__label">{{
              customLabel.os_paydate || "应付日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.os_paydate, 'yyyy-MM-dd')
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pp_text1 || '自定义字段1'"
          v-model="form.main.pp_text1" slot="pp_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text2 || '自定义字段2'"
          v-model="form.main.pp_text2" slot="pp_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text3 || '自定义字段3'"
          v-model="form.main.pp_text3" slot="pp_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text4 || '自定义字段4'"
          v-model="form.main.pp_text4" slot="pp_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pp_text5 || '自定义字段5'"
          v-model="form.main.pp_text5" slot="pp_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.osd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="osd_caname">
              <label class="weui-form-preview__label">{{
                customLabel.osd_caname || "调账科目"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.osd_cacode }} {{ item.osd_caname }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="osd_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.osd_nowbalance || "调账金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.osd_nowbalance, "#,##0.00")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="osd_remark">
              <label class="weui-form-preview__label">{{
                customLabel.osd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.osd_remark
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.ppd_text1 || '自定义字段1'"
            v-model="item.ppd_text1" slot="ppd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text2 || '自定义字段2'"
            v-model="item.ppd_text2" slot="ppd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text3 || '自定义字段3'"
            v-model="item.ppd_text3" slot="ppd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text4 || '自定义字段4'"
            v-model="item.ppd_text4" slot="ppd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.ppd_text5 || '自定义字段5'"
            v-model="item.ppd_text5" slot="ppd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.os_remark">
            <label class="weui-form-preview__label">调账原因</label>
            <span class="weui-form-preview__value">{{
              form.main.os_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.os_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.os_auditman
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";
// import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField
    // CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/money/othpayables",
      caller: "OthPayables",
      xtype: "money-othpayables-formpanel",
    };
  },
};
</script>